import BaseModelAPI from '../BaseModelAPI';

export default class BillOfProcessDetail extends BaseModelAPI {
	static entity = 'billofprocessdetail';
	static entityName = 'billofprocessdetail';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.sequence = 0;
			this.billOfProcessId = '';
			this.billOfProcess = {};
			this.machineId = '';
			this.machine = {};
			this.subProcessId = '';
			this.subProcess = {};
			this.diesOrJigNumber = '';
			this.subProcessNumber = '';
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}